// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard_sharedAvatar__Q0153 {\n  border: solid 1px #fff;\n  margin-left: -8px;\n}", "",{"version":3,"sources":["webpack://./src/wab/client/components/dashboard/dashboard.module.scss"],"names":[],"mappings":"AAGA;EACE,sBAAA;EACA,iBAAA;AAFF","sourcesContent":["//\n// Shared component.\n//\n.sharedAvatar {\n  border: solid 1px #fff;\n  margin-left: -8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sharedAvatar": "dashboard_sharedAvatar__Q0153"
};
export default ___CSS_LOADER_EXPORT___;
